const LandUse = () => {
  const LandUseReferralsData = [
    {
      year: 2022,
      total_lurs: 327,
      commerical_lurs: 145,
      residential_lurs: 110,
      mixed_use_lurs: 18,
      other_lurs: 54,
      unit: 'count',
    },
    {
      year: 2021,
      total_lurs: 314,
      commerical_lurs: 129,
      residential_lurs: 126,
      mixed_use_lurs: 5,
      other_lurs: 54,
      unit: 'count',
    },
    {
      year: 2020,
      total_lurs: 223,
      commerical_lurs: 100,
      residential_lurs: 50,
      mixed_use_lurs: 24,
      other_lurs: 49,
      unit: 'count',
    },
    {
      year: 2019,
      total_lurs: 193,
      commerical_lurs: 98,
      residential_lurs: 66,
      mixed_use_lurs: 6,
      other_lurs: 23,
      unit: 'count',
    },
    {
      year: 2018,
      total_lurs: 216,
      commerical_lurs: 102,
      residential_lurs: 69,
      mixed_use_lurs: 1,
      other_lurs: 44,
      unit: 'count',
    },
    {
      year: 2017,
      total_lurs: 198,
      commerical_lurs: 128,
      residential_lurs: 43,
      mixed_use_lurs: 2,
      other_lurs: 25,
      unit: 'count',
    },
    {
      year: 2016,
      total_lurs: 265,
      commerical_lurs: 147,
      residential_lurs: 60,
      mixed_use_lurs: 4,
      other_lurs: 54,
      unit: 'count',
    },
    {
      year: 2015,
      total_lurs: 198,
      commerical_lurs: 96,
      residential_lurs: 54,
      mixed_use_lurs: 2,
      other_lurs: 46,
      unit: 'count',
    },
    {
      year: 2014,
      total_lurs: 154,
      commerical_lurs: 81,
      residential_lurs: 44,
      mixed_use_lurs: 0,
      other_lurs: 29,
      unit: 'count',
    },
  ];

  // Declare and configure request overview table
  const LandUseReferrals = new requestTable({
    container: '#land-use-referrals-table',
    filterEnabled: false,
    tableHeaders: {
      year: 'Year',
      total_lurs: 'Total',
      commerical_lurs: 'Commercial',
      residential_lurs: 'Residential',
      mixed_use_lurs: 'Mixed Use',
      other_lurs: 'Other *',
    },
    tableActions: [],
    tableData: LandUseReferralsData,
  });
  LandUseReferrals.buildTable();
  
};
